import React from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionsContext';
import Error404 from '../components/Errors/Error404';
import { matchPath } from 'react-router-dom';
import { useSessionExpiration } from '../hooks/useSessionExpiration';
import ExpiredSessionModal from '../components/Expired/ExpiredSessionModal';
import { canAccessRoute, isRouteDisabled } from '../utils/routeAccess';
import Loading from '../components/Loading';
import { ROUTES } from './routePaths';

const ProtectedRoute: React.FC = () => {
    const { user, isAuthenticated, loading: authLoading, logout } = useAuth();
    const { permissions, disabledPaths, loading: permissionsLoading } = usePermissions();
    const location = useLocation();
    const navigate = useNavigate();
    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();

    const handleCloseExpiredModal = () => {
        setIsSessionExpired(false);
        logout(); 
        navigate('/', { replace: true });
    };

    if (authLoading || permissionsLoading) {
        const isClientRoute = [
            ROUTES.reservaYa, ROUTES.misCitas, ROUTES.solicitudesReserva,
            ROUTES.perfil, ROUTES.miDashboard, ROUTES.parati, ROUTES.miCorrespondencia,
        ].some(path => matchPath({ path, end: false }, location.pathname));
        return isClientRoute
            ? <Loading text="Cargando..." />
            : <div role="status" aria-label="Cargando permisos" aria-busy="true" style={{ minHeight: '100dvh', background: '#fff' }} />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    const path = location.pathname;
    if (isRouteDisabled(path, disabledPaths)) return <Error404 />;
    const allowed = canAccessRoute(path, user?.role, permissions, disabledPaths);
    const correspondenceBenefit = path.startsWith('/mi-correspondencia') &&
        Boolean(user?.es_domiciliado || user?.tiene_correspondencia_habilitada);
    if (!allowed && !correspondenceBenefit) return <Error404 />;

    return (
        <>
            <ExpiredSessionModal
                isOpen={isSessionExpired}
                onClose={handleCloseExpiredModal}
            />
            <Outlet />
        </>
    );
};

export default ProtectedRoute;

